import * as types from './types'
import {
  createPriceRule as createPriceRuleRequest,
  deletePriceRule as deletePriceRuleRequest,
  getPriceRules as getPriceRulesRequest,
  getPriceRulesSettings as getPriceRulesSettingsRequest,
  updatePriceRule as updatePriceRuleRequest,
  updatePriceRulesSettings as updatePriceRulesSettingsRequest
} from '@cbgms/api/modules/price-rules/requests'
import { POSTPriceRuleBody, PUTPriceRuleBody, PUTPriceRulesSettingsBody } from '@cbgms/api/modules/price-rules'

export const loadPriceRulesSettings = () => ({
  type: [types.LOAD_PRICE_RULES_SETTINGS, types.LOAD_PRICE_RULES_SETTINGS_SUCCESS, types.LOAD_PRICE_RULES_SETTINGS_FAILED],
  payload: {
    api: 'gms',
    request: getPriceRulesSettingsRequest()
  }
})

export const updatePriceRulesSettings = (data: PUTPriceRulesSettingsBody) => ({
  type: [types.UPDATE_PRICE_RULES_SETTINGS, types.UPDATE_PRICE_RULES_SETTINGS_SUCCESS, types.UPDATE_PRICE_RULES_SETTINGS_FAILED],
  payload: {
    api: 'gms',
    request: updatePriceRulesSettingsRequest(data)
  }
})

export const loadPriceRules = () => ({
  type: [types.LOAD_PRICE_RULES, types.LOAD_PRICE_RULES_SUCCESS, types.LOAD_PRICE_RULES],
  payload: {
    api: 'gms',
    request: getPriceRulesRequest()
  }
})

export const createPriceRule = (data: POSTPriceRuleBody) => ({
  type: [types.CREATE_PRICE_RULE, types.CREATE_PRICE_RULE_SUCCESS, types.CREATE_PRICE_RULE_FAILED],
  payload: {
    api: 'gms',
    request: createPriceRuleRequest(data)
  }
})

export const updatePriceRule = (UUID: string, data: PUTPriceRuleBody) => ({
  type: [types.UPDATE_PRICE_RULE, types.UPDATE_PRICE_RULE_SUCCESS, types.UPDATE_PRICE_RULE_FAILED],
  payload: {
    api: 'gms',
    request: updatePriceRuleRequest(UUID, data)
  }
})

export const deletePriceRule = (UUID: string) => ({
  type: [types.DELETE_PRICE_RULE, types.DELETE_PRICE_RULE_SUCCESS, types.DELETE_PRICE_RULE_FAILED],
  payload: {
    api: 'gms',
    request: deletePriceRuleRequest(UUID)
  }
})
